import { createSelector } from 'reselect';
import groupBy from 'lodash.groupby';
import { convertArrayToObject } from 'utils/helpers';

const adminLevelsSelector = (state) => state.newAdminLevels;

export const selectDeletingAdminLevelItem = createSelector(
  [adminLevelsSelector],
  (newAdminLevels) => newAdminLevels.deletingAdminLevelItem
);

export const selectAdminLevel = createSelector(
  [adminLevelsSelector],
  (newAdminLevels) => newAdminLevels.levels
);

export const selectIndexedAdminLevel = createSelector(
  [adminLevelsSelector],
  (newAdminLevels) => convertArrayToObject(newAdminLevels.levels, 'id')
);

export const selectAdminLevelData = createSelector(
  [adminLevelsSelector],
  (newAdminLevels) => newAdminLevels.data
);

export const selectItemsByAdminLevelId = createSelector(
  [adminLevelsSelector],
  (newAdminLevels) => groupBy(newAdminLevels.items, 'administrationLevel.id')
);

export const selectItemsByParentId = createSelector(
  [adminLevelsSelector],
  (newAdminLevels) => groupBy(newAdminLevels.items, 'parent.id')
);

export const selectAdminLevelItems = createSelector(
  [adminLevelsSelector],
  (newAdminLevels) => newAdminLevels.items
);

export const selectIndexedAdminLevelItems = createSelector(
  [adminLevelsSelector],
  (newAdminLevels) => convertArrayToObject(newAdminLevels.items, 'id')
);

export const selectAdminLevelsLoading = createSelector(
  [adminLevelsSelector],
  (newAdminLevels) => newAdminLevels.loadingLevels
);

export const selectAdminLevelsSaving = createSelector(
  [adminLevelsSelector],
  (newAdminLevels) => newAdminLevels.savingLevels
);

export const selectAdminLevelItemsSaving = createSelector(
  [adminLevelsSelector],
  (newAdminLevels) => newAdminLevels.savingItems
);

export const selectLastAdminLevel = createSelector(
  [adminLevelsSelector],
  (newAdminLevels) => newAdminLevels.levels[newAdminLevels.levels.length - 1]
);
